import {Earnings} from './earnings.model'

export class MilesPointsEarnings {
    miles: Earnings;
    points: Earnings;
}
  


// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/points-estimate/miles-points-earnings.model.ts